var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomecareServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6e83b7",
    d: "m256 59.656 221.172 221.172L502 256 256 10 10 256l24.828 24.828z",
    opacity: 1,
    "data-original": "#6e83b7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edeff1",
    d: "m256 59.656 194 194V502H62V253.656z",
    opacity: 1,
    "data-original": "#edeff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#466089",
    d: "M256 389.154c-42.232 0-76.468-34.236-76.468-76.468v-25.984h152.935v25.984c.001 42.233-34.235 76.468-76.467 76.468z",
    opacity: 1,
    "data-original": "#466089"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb0aa",
    d: "M392.603 437.359V502H119.397v-64.641c0-21.076 14.771-39.268 35.398-43.595l71.508-15.003h59.392l71.508 15.003c20.629 4.327 35.4 22.519 35.4 43.595z",
    opacity: 1,
    "data-original": "#ffb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcb98b",
    d: "m256 417.705-29.696-38.944v-26.727h59.392v26.727z",
    opacity: 1,
    "data-original": "#fcb98b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd3b3",
    d: "M186.956 209.052v81.362c0 38.132 30.912 69.044 69.044 69.044s69.044-30.912 69.044-69.044V207.38z",
    opacity: 1,
    "data-original": "#ffd3b3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcb98b",
    d: "M332.468 286.703c13.121 0 23.757-10.636 23.757-23.757s-10.636-23.757-23.757-23.757h-7.424v47.514zM179.532 286.703c-13.121 0-23.757-10.636-23.757-23.757s10.636-23.757 23.757-23.757h7.424v47.514z",
    opacity: 1,
    "data-original": "#fcb98b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7b7b",
    d: "M325.952 466.364h16V502h-16zM170.048 466.364h16V502h-16z",
    opacity: 1,
    "data-original": "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e83b7",
    d: "M256 136.737c-42.232 0-76.468 34.236-76.468 76.468v25.984h7.424v47.514l14.848-40.089c82.601 0 97.672-31.765 97.673-31.767l2.595 1.915a30.252 30.252 0 0 1 11.592 17.879l11.379 52.062V239.19h7.424v-25.984c.001-42.234-34.235-76.469-76.467-76.469z",
    opacity: 1,
    "data-original": "#6e83b7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7b7b",
    d: "M285.696 378.761 256 417.705l-29.696-38.944-34.979 7.338L256 472.304l64.675-86.205z",
    opacity: 1,
    "data-original": "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edeff1",
    d: "M283.469 464.304h35.636v16h-35.636z",
    opacity: 1,
    "data-original": "#edeff1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomecareServices);
export default __webpack_public_path__ + "static/media/homecare_services.c41a01d858de35652253cf7ceab43c44.svg";
export { ForwardRef as ReactComponent };